import { render, staticRenderFns } from "./payrollHeader.vue?vue&type=template&id=2b6439f8&scoped=true"
import script from "./payrollHeader.vue?vue&type=script&lang=js"
export * from "./payrollHeader.vue?vue&type=script&lang=js"
import style0 from "./payrollHeader.vue?vue&type=style&index=0&id=2b6439f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6439f8",
  null
  
)

export default component.exports